<template>
<!--  简历是否可编辑（会员限制）不可编辑的简历添加filter滤镜变成黑白-->
  <div :class="['online-cv', !cvData.can_editable && showTip ? 'filter-dom' : '']" @click="editorCv">
<!--    <div v-if="loadingShow" class="cv-loading-wrapper flex-center">-->
<!--      <img src="https://files.wondercv.com/mobile/cvs/loading.gif" alt="">-->
<!--    </div>-->
    <div class="cv-container" data-growing-container v-if="showTip">
      <div class="cv-message">
        <div class="cv-avatar">
          <img :src="cvData.is_mentor ? 'https://files.wondercv.com/service_cv.png' : cvData.can_editable ? cvData.avatar_url || 'https://files.wondercv.com/mobile/cvs/cv-logo.png' : 'https://files.wondercv.com/expired-cv-min.png'" alt="">
        </div>
        <div class="cv-detail">
          <div class="cv-name">
            <div :class="['name', cvData.can_editable ? '' : 'filter-dom']">{{ cvData.cv_name || '未命名超级简历' }}</div>
            <span class="iconfont iconmore-horizontal" :style="{opacity: showTip ? 1 : 0}" @click.stop="cvOperation" />
          </div>
          <div class="cv-score">
            <div class="score">{{ cvData.score === null ? 40 : cvData.score }}分</div>
            <div class="lang">{{ cvData.lang === 'cn' ? '中文简历' : '英文简历'}}</div>
          </div>
          <div class="update-at">{{ (onlineCvTime || cvData.update_time) | timeFormatFilter(true) }}</div>
        </div>
      </div>
    </div>
    <div class="cv-container" data-growing-container v-else>
      <div class="cv-message">
        <div class="cv-avatar">
          <img class="avatar" v-if="cvData.profile.avatar_url" :src="cvData.profile.avatar_url" alt="">
          <img class="cv-logo" v-else src="https://files.wondercv.com/mobile/cvs/cv-logo.png" alt="">
        </div>
        <div class="cv-detail">
          <div class="cv-name">
            <div :class="['name']">{{ cvData.profile.username || '未命名超级简历' }}</div>
            <span class="iconfont iconmore-horizontal" :style="{opacity: showTip ? 1 : 0}" @click.stop="" />
          </div>
          <div class="cv-score" v-if="cvData.work_experiences.length && !userData.is_student">
<!--            <div class="score">{{ cvData.score }}分</div>-->
<!--            <div class="lang">{{ cvData.lang === 'cn' ? '中文简历' : '英文简历'}}</div>-->
            <div class="lang" style="margin-left: 0">
              {{ cvData.work_experiences[0].title }}
            </div>
          </div>
          <div class="cv-score" v-else-if="cvData.education_experiences.length">
            <div class="score" v-if="uniSchool">{{ uniSchool }}</div>
            <div class="lang" v-if="degree" :style="{marginLeft: uniSchool ? '12px' : '0'}">{{ degree }}</div>
          </div>
          <div class="update-at">{{ (onlineCvTime || cvData.update_time) | timeFormatFilter(true) }} 更新</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {envMixin} from "@/assets/js/mixin/global";
import {componentsMixin} from "@/assets/js/mixin/components";
import {onlineMixin} from "@/assets/js/mixin/cv";
import {userMixin} from "@/assets/js/mixin/user";

export default {
  name: "CvItemCard",
  mixins: [ envMixin, componentsMixin, onlineMixin, userMixin ],
  props: {
    cvData: {
      type: Object,
      default: () => {}
    },
    onlineCvTime: {
      type: String,
      default: ""
    },
    // 是否显示...简历操作按钮   不显示的为在线简历
    showTip: {
      type: Boolean,
      default: true
    },
    uniSchool: {
      type: String,
      default: ""
    },
    degree: {
      type: String,
      default: ""
    }
  },
  data () {
    return {

    }
  },
  watch: {

  },
  methods: {
    // 点击简历卡片事件，点击推荐简历跳转在线简历显示页，点击其他简历跳转editor页
    editorCv() {
      if (this.showTip) {
        this.$emit('goEditor', this.cvData)
      } else {
        this.$fn.jump(
          `${window.location.origin}/cvs/online/${this.cvData.basic_info.token}/preview`,
          () => {
            this.$router.push(`/cvs/online/${this.cvData.basic_info.token}/preview`)
          }
        )
      }
    },
    // 弹出简历操作弹窗
    cvOperation() {
      this.$emit('cvOperation', this.cvData)
    }
  },
  mounted () {
    // if (!this.showTip) {
    //   setTimeout(() => {
    //     console.log("mounted=========>",this.cvData)
    //     console.log(this.onlineCvTime,"============>onlineCvTime")
    //   },2000)
    // }
  }

}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/global/variable';
@import '@/assets/scss/global/mixin';
.filter-dom {
  /*兼容FF*/
  filter: url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\'><filter id=\'grayscale\'><feColorMatrix type=\'matrix\' values=\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\'/></filter></svg>#grayscale");
  /*兼容IE内核*/
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  /*兼容其它，谷歌之类的*/
  -webkit-filter: grayscale(1);
  color: #9c9c9c!important;
}
.online-cv {
  width: 327px;
  height: 102px;
  padding: 16px 14px;
  box-shadow: 0 1px 10px 0 rgba(3, 47, 129, 0.08);
  border-radius: 6px;
  .cv-loading-wrapper {
    width: 100%;
    height: 100%;
    img {
      height: 100%;
      width: 50%;
      object-fit: contain;
    }
  }
  .cv-container {
    width: 100%;
    height: 100%;
    .cv-message {
      width: 100%;
      height: 70px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .cv-avatar {
        width: 56px;
        height: 70px;
        border-radius: 4px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: fill;
        }
      }
      .cv-detail {
        width: calc(100% - 66px);
        height: 100%;
        .cv-name {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .name {
            color: #404040;
            font-size: 16px;
            font-weight: 500;
            @include ellipsis(calc(100% - 50px))
          }
          .iconfont {
            color: #cfcfcf;
            font-size: 28px;
          }
        }
        .cv-score {
          display: flex;
          align-items: center;
          font-size: 11px;
          .score {
            //width: 41px;
            padding: 0 8px;
            height: 20px;
            background: #FFF6F4;
            border-radius: 2px;
            line-height: 20px;
            text-align: center;
            color: #ff6644;
            font-weight: 500;
          }
          .lang {
            //width: 60px;
            padding: 0 8px;
            margin-left: 12px;
            height: 20px;
            background: #F5F8FF;
            border-radius: 2px;
            line-height: 20px;
            color: #669BFF;
            font-weight: 500;
          }
        }
        .update-at {
          font-size: 11px;
          color: #9c9c9c;
          margin-top: 7px;
        }
      }
    }
  }
}
</style>